const styles = {
  banner: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 2,
    backgroundColor: "#EFEAF8",
    border: "1px solid #DCD2F0",
    borderRadius: "14px",
    px: 2,
    py: 1.5,
    mb: 1,
  },
  icon: {
    flexShrink: 0,
    width: 32,
    height: 32,
    borderRadius: "10px",
    backgroundColor: "#fff",
    border: "1px solid #E2D8F4",
    color: "#6F4FBF",
    fontSize: 16,
    display: "grid",
    placeItems: "center",
  },
  text: {
    flex: 1,
    minWidth: 200,
    fontSize: 13,
    lineHeight: 1.4,
  },
  snippet: {
    color: "#4B2E94",
    fontWeight: 600,
  },
  description: {
    color: "#6F5BA0",
  },
  button: {
    flexShrink: 0,
    backgroundColor: "#4B2E94",
    color: "#fff",
    borderRadius: 9999,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0.2,
    px: 1.75,
    py: 0.875,
    "&:hover": {
      backgroundColor: "#3A1F7E",
    },
  },
  dismiss: {
    flexShrink: 0,
    width: 28,
    height: 28,
    borderRadius: "50%",
    color: "#6F5BA0",
    fontSize: 14,
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.05)",
      color: "#4B2E94",
    },
  },
};

export default styles;
